import React, { FC } from 'react';
import { connect } from 'react-redux';
import { openInput } from '../../../actions/baseActions';
import Helper from '../../modules/Helper';
import FadeTransition from './FadeTransition';

type BodyHighlightProps = {
	openedInput?: string;
	openInput: (name?: string | null) => void;
};

const BodyHighlight: FC<BodyHighlightProps> = (props) => {
	const { openedInput } = props;
	return (
		<FadeTransition timeout={600} in={!Helper.isEmpty(openedInput) && openedInput !== 'mobile-select-box'}>
			<div onClick={() => props.openInput(null)} id="body-highlight" />
			{/* <></> */}
		</FadeTransition>
	);
};

const mapStateToProps = (state: any) => ({
	openedInput: state.base.openedInput,
});

export default React.memo(connect(mapStateToProps, { openInput })(BodyHighlight));
